var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_373_32180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 1.33398C11.6827 1.33398 14.6673 4.31865 14.6673 8.00065C14.6673 11.6827 11.6827 14.6673 8.00065 14.6673C4.31865 14.6673 1.33398 11.6827 1.33398 8.00065C1.33398 4.31865 4.31865 1.33398 8.00065 1.33398ZM7.99398 6.66732H7.33398C7.16406 6.66751 7.00063 6.73257 6.87707 6.84922C6.75351 6.96586 6.67916 7.12529 6.6692 7.29491C6.65924 7.46454 6.71443 7.63157 6.82349 7.76187C6.93255 7.89217 7.08725 7.97591 7.25598 7.99598L7.33398 8.00065V11.3273C7.33398 11.674 7.59665 11.9607 7.93398 11.9966L8.00732 12.0007H8.33398C8.47419 12.0007 8.61083 11.9565 8.72447 11.8743C8.83812 11.7922 8.92297 11.6763 8.96698 11.5432C9.01098 11.4101 9.0119 11.2665 8.96959 11.1328C8.92728 10.9991 8.8439 10.8822 8.73132 10.7987L8.66732 10.7567V7.34065C8.66732 6.99398 8.40465 6.70732 8.06732 6.67132L7.99398 6.66732ZM8.00065 4.66732C7.82384 4.66732 7.65427 4.73756 7.52925 4.86258C7.40422 4.9876 7.33398 5.15717 7.33398 5.33398C7.33398 5.5108 7.40422 5.68036 7.52925 5.80539C7.65427 5.93041 7.82384 6.00065 8.00065 6.00065C8.17746 6.00065 8.34703 5.93041 8.47205 5.80539C8.59708 5.68036 8.66732 5.5108 8.66732 5.33398C8.66732 5.15717 8.59708 4.9876 8.47205 4.86258C8.34703 4.73756 8.17746 4.66732 8.00065 4.66732Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_32180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationFill);
export default __webpack_public_path__ + "static/media/information_fill.5d693ba8d0fd3a6fa1128da53022988a.svg";
export { ForwardRef as ReactComponent };